// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0b97bc7d","977":"62417129"}[chunkId] + ".chunk.js";
};